<template>
  <tr>
    <td>
      <router-link :to="`/purchase-return/${item.id}/view`" :key="item.code" title="View Purchase Return">
        {{ item.code }}
      </router-link>
    </td>
  	<td>
      <router-link :to="`/purchase/view/${item.purchase_id}`" :key="item.purchase_code" title="View Purchase">
        {{ item.purchase_code }}
      </router-link>
    </td>
    <td>{{ formatMysqlDate(item.added_time, 'Do MMM, YYYY') }}</td>
    <td class="text-xs-right">{{ item.grandtotal | roundValue }}</td>
    <td class="text-xs-center">{{ status }}</td>
    <td class="align-center justify-center layout px-0" v-if="!viewMode">
      <router-link :to="`/purchase-return/${item.id}/approve`" title="Approve Purchase Return" v-if="isPending && hasAdminPrivilage">
        <v-icon small color="green" class="mr-1">done</v-icon>
      </router-link>
      <v-icon small class="mr-1" color="red" v-if="isPending && hasAdminPrivilage" @click="$emit('cancel', item)" title="Cancel Purchase Return">clear</v-icon>
      <router-link :to="`/purchase-return/${item.id}`" v-if="hasEditAccess && isPending" title="Edit Purchase Return">
        <v-icon small class="mr-1">edit</v-icon>
      </router-link>
    </td>
  </tr>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    viewMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      
    }
  },
  
  methods: {

  },

  mounted () {
  	
  },

  computed: {
    
    isPending () {
      return this.item.status == this.config.purchaseReturnStatus.pending
    },

    isApproved () {
      return this.item.status == this.config.purchaseReturnStatus.approved
    },

    isCancelled () {
      return this.item.status == this.config.purchaseReturnStatus.cancelled
    },

    status () {
      let status = ""
      switch(this.item.status) {
        case this.config.purchaseReturnStatus.pending:
          status = "Pending"
        break
        case this.config.purchaseReturnStatus.approved:
          status = "Approved"
        break
        case this.config.purchaseReturnStatus.cancelled:
          status = "Cancelled"
        break
      }
      return status
    }

  },

  watch: {
    
  }
}
</script>